<template>
  <b-modal
    :visible="value"
    :title="title"
    size="sm"
    hide-footer
    centered
    @change="modalChangeEvent"
  >
    <div class="row">
      <b-col sm="12" md="12">
        <BfInput label="Nueva contraseña" v-model="password" data-key="password" type="password"/>
      </b-col>
    </div>

    <div class="mt-4 text-right">
      <BfButton variant="red" class="mr-3" @click="modalChangeEvent(false)">Cancelar</BfButton>
      <BfButton variant="secondary" @click="confirmChange">Confirmar</BfButton>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ChangePasswordModal',

  data() {
    return {
      password: '',
    };
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
    },

    value: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    modalChangeEvent(visible) {
      this.$emit('input', visible);
    },

    confirmChange() {
      if (this.password.length <= 5) {
        this.$bfNotify({
          title: 'Actualizado',
          message:
            'Parece que la contraseña introducida es muy corta. Introduce una más larga.',
          type: 'error',
        });
      } else {
        this.$emit('updatePassword', this.password);
      }
    },
  },
};
</script>
